var map = {
	"./dupla1.png": 1074,
	"./dupla2.png": 3854,
	"./dupla3.png": 1562,
	"./dupla4.png": 1158,
	"./dupla5.png": 2021,
	"./dupla6.png": 2664,
	"./dupla7.png": 3502,
	"./dupla8.png": 2474,
	"./dupla9.png": 8989
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3274;